export const ROLE_ADMINISTRATOR = "1";
export const ROLE_RIGHTSLINE_PRODUCT_GATE = "2";
export const ROLE_BULK_DATE_MATH_TOOL = "3";
export const ROLE_AIR_DATE_INGESTION_TOOL = "4";
export const ROLE_WON_ERROR_REPORT = "5";
export const ROLE_APOLLO_ERROR_REPORT = "6";
export const ROLE_JOB_TRACKER = "7";
export const ROLE_LEGAL_ADMIN = "8";
export const ROLE_LEGAL_USER = "9";
export const ROLE_DEAL_VERSIONING = "10";
export const ROLE_PRODUCT_COMMENTS_ADMIN = "11";
export const ROLE_TAP_USER = "12";
export const ROLE_RIGHTSETS_USER = "13";
export const ROLE_RIGHTSETS_ASSOCIATE_USER = "14";
export const ROLE_PMX_USER = "15";
export const ROLE_TAP_ADMIN = "16";
export const ROLE_DIGITAL_STORES = "23";
export const FLEXIBLE_WINDOW_FLAG_ENABLED = true;
export const ENABLED_FEATURE_FLAGS = "";
//APAC_NEW_WINDOWS_ATTRIBUTES,TAP_OFFER_EPISODE_TIER_AND_EPISODE_EMA_PRICE_TYPE

// Role ID to label mapping
export const ROLE_LABELS = {
  [ROLE_ADMINISTRATOR]: "ADMINISTRATOR",
  [ROLE_RIGHTSLINE_PRODUCT_GATE]: "RIGHTSLINE PRODUCT GATE",
  [ROLE_BULK_DATE_MATH_TOOL]: "BULK DATE MATH TOOL",
  [ROLE_AIR_DATE_INGESTION_TOOL]: "AIR DATE INGESTION TOOL",
  [ROLE_WON_ERROR_REPORT]: "WON ERROR REPORT",
  [ROLE_APOLLO_ERROR_REPORT]: "APOLLO ERROR REPORT",
  [ROLE_JOB_TRACKER]: "JOB TRACKER",
  [ROLE_LEGAL_ADMIN]: "LEGAL ADMIN",
  [ROLE_LEGAL_USER]: "LEGAL USER",
  [ROLE_DEAL_VERSIONING]: "DEAL VERSIONING",
  [ROLE_PRODUCT_COMMENTS_ADMIN]: "PRODUCT COMMENTS ADMIN",
  [ROLE_TAP_USER]: "TAP USER",
  [ROLE_RIGHTSETS_USER]: "RIGHTSETS USER",
  [ROLE_RIGHTSETS_ASSOCIATE_USER]: "RIGHTSETS ASSOCIATE USER",
  [ROLE_PMX_USER]: "PMX USER",
  [ROLE_TAP_ADMIN]: "TAP ADMIN",
  [ROLE_DIGITAL_STORES]: "DIGITAL STORES",
};

/**
 * Maps an array of role IDs to their corresponding labels
 * @param {string[]} roleIds - Array of role ID strings
 * @returns {string} Semicolon-separated string of role labels
 */
export function mapRolesToLabels(roleIds) {
  return roleIds
    .filter((id) => ROLE_LABELS[id])
    .map((id) => ROLE_LABELS[id])
    .join(", ");
}
